import { render, staticRenderFns } from "./refundaddr.vue?vue&type=template&id=5a3be896&scoped=true&"
import script from "./refundaddr.vue?vue&type=script&lang=js&"
export * from "./refundaddr.vue?vue&type=script&lang=js&"
import style0 from "./refundaddr.vue?vue&type=style&index=0&id=5a3be896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3be896",
  null
  
)

export default component.exports